import { redirect } from 'react-router-dom';
import { fetchCreditCards, fetchFraudTracking } from '@api';
import { useApplicationStore } from '@data';
import { AvailableSubscription } from '@types';
import { fetchSubscriptionsAvailableToPatient } from 'api/subscriptions';
import { refetchAndSetPatientProfile } from './utils';

export interface CompleteBookingLoaderResponse {
  availableMhtSubscription: AvailableSubscription | null;
}

export default async function completeBookingLoader(): Promise<
  CompleteBookingLoaderResponse | Response | null
> {
  const { auth, patient, reservedVisit, setFraudData } =
    useApplicationStore.getState();
  const { accessToken } = auth;

  if (!accessToken || !reservedVisit) {
    return redirect('/services');
  }

  const untypedPromises: Promise<unknown>[] = [];

  if (!patient.creditCards) {
    try {
      if (!patient.patientProfile) {
        untypedPromises.push(refetchAndSetPatientProfile());
      }

      untypedPromises.push(
        fetchCreditCards().then((x) => patient.setPatientCreditCards(x)),
      );
    } catch (error) {
      console.log(error);
    }
  }

  untypedPromises.push(
    fetchFraudTracking().then((x) =>
      setFraudData(x.addCreditCardInvalidAttemptSummary),
    ),
  );

  try {
    const [subscriptions] = await Promise.all([
      fetchSubscriptionsAvailableToPatient(),
      ...untypedPromises,
    ]);

    // * NOTE: There is only one subscription currently and it is MHT. We have yet to build out how to handle
    //   identifying different subscriptions, but when we have multiple and the BE has a way to do so, this will need to be updated.
    const [availableMhtSubscription] = subscriptions;

    return { availableMhtSubscription };
  } catch {
    return {
      availableMhtSubscription: null,
    };
  }
}
